'use client';

import { installNativeScripts, isLottolandNativeAppUserAgent, markNativeAppDocument, subscribeNativeAuthEvents } from '@shared/native';
import { useEffect, useLayoutEffect } from 'react';

function NativeScripts() {
  useLayoutEffect(() => subscribeNativeAuthEvents(), []);

  // Fallback for pages React renders on the client (404 and server errors), where the inline detection script never runs.
  useLayoutEffect(() => markNativeAppDocument(), []);

  useEffect(() => {
    const userAgent = navigator.userAgent;

    if (!isLottolandNativeAppUserAgent(userAgent)) {
      return;
    }

    installNativeScripts(userAgent);
  }, []);

  return null;
}

export { NativeScripts };
